"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMeetingDto = exports.CreateMeetingDocumentDto = exports.EmployeeParticipantsDto = exports.CompanyParticipantsDto = exports.InsurerParticipantsDto = exports.TpaParticipantsDto = exports.ParticipantsDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class ParticipantsDto {
}
exports.ParticipantsDto = ParticipantsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Company Contact Person IDs",
        type: [Number],
    }),
    (0, class_validator_1.IsArray)({ message: "Company Contact Person must be an array." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({
        each: true,
        message: "Each Company Contact Person ID must be a number.",
    }),
    tslib_1.__metadata("design:type", Object)
], ParticipantsDto.prototype, "companyContactPerson", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Employee IDs", type: [Number] }),
    (0, class_validator_1.IsArray)({ message: "Employees must be an array." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ each: true, message: "Each Employee ID must be a number." }),
    tslib_1.__metadata("design:type", Object)
], ParticipantsDto.prototype, "employees", void 0);
class TpaParticipantsDto {
}
exports.TpaParticipantsDto = TpaParticipantsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "TPA ID", example: 211 }),
    (0, class_validator_1.IsInt)({ message: "TPA ID must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "TPA ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], TpaParticipantsDto.prototype, "tpaId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "TPA Contact Person IDs",
        type: [Number],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "TPA Contact Person must be an array." }),
    (0, class_validator_1.ArrayNotEmpty)({ message: "At least one TPA Contact Person is required." }),
    (0, class_validator_1.IsInt)({
        each: true,
        message: "Each TPA Contact Person ID must be a number.",
    }),
    tslib_1.__metadata("design:type", Array)
], TpaParticipantsDto.prototype, "tpaContactPerson", void 0);
class InsurerParticipantsDto {
}
exports.InsurerParticipantsDto = InsurerParticipantsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Insurer ID", example: 357 }),
    (0, class_validator_1.IsInt)({ message: "Insurer ID must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Insurer ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], InsurerParticipantsDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Insurer Contact Person IDs",
        type: [Number],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Insurer Contact Person must be an array." }),
    (0, class_validator_1.ArrayNotEmpty)({
        message: "At least one Insurer Contact Person is required.",
    }),
    (0, class_validator_1.IsInt)({
        each: true,
        message: "Each Insurer Contact Person ID must be a number.",
    }),
    tslib_1.__metadata("design:type", Array)
], InsurerParticipantsDto.prototype, "insurerContactPerson", void 0);
class CompanyParticipantsDto {
}
exports.CompanyParticipantsDto = CompanyParticipantsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company ID", example: 357 }),
    (0, class_validator_1.IsInt)({ message: "Company ID must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Company ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CompanyParticipantsDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Company Contact Person IDs",
        type: [Number],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Company Contact Person must be an array." }),
    (0, class_validator_1.ArrayNotEmpty)({
        message: "At least one Company Contact Person is required.",
    }),
    (0, class_validator_1.IsInt)({
        each: true,
        message: "Each Company Contact Person ID must be a number.",
    }),
    tslib_1.__metadata("design:type", Array)
], CompanyParticipantsDto.prototype, "companyContactPerson", void 0);
class EmployeeParticipantsDto {
}
exports.EmployeeParticipantsDto = EmployeeParticipantsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Employee IDs", type: [Number] }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Employees must be an array." }),
    (0, class_validator_1.ArrayNotEmpty)({ message: "At least one Employee is required." }),
    (0, class_validator_1.IsInt)({ each: true, message: "Each Employee ID must be a number." }),
    tslib_1.__metadata("design:type", Array)
], EmployeeParticipantsDto.prototype, "employees", void 0);
class CreateMeetingDocumentDto {
}
exports.CreateMeetingDocumentDto = CreateMeetingDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Document ID must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDocumentDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 101,
        description: "The lookup ID for the document type.",
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDocumentDto.prototype, "documentTypeLid", void 0);
class CreateMeetingDto {
}
exports.CreateMeetingDto = CreateMeetingDto;
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Activity id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Activity id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Opportunity id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Opportunity id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting Type ID",
        example: 343,
    }),
    (0, class_validator_1.IsInt)({ message: "Meeting type must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting type is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Meeting type must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "meetingTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Company id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Company id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting Date",
        type: String,
        example: "2025-06-20",
    }),
    (0, class_validator_1.IsDate)({ message: "Meeting Date must be a valid date." }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting Date is required." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to midnight
        if (value < today) {
            throw new common_1.BadRequestException("The meeting date cannot be a past date. Please provide a valid date.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateMeetingDto.prototype, "meetingDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Start Time (time with time zone, ISO 8601 format)",
        type: String,
        example: "10:00:00+05:30",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Start time is required." }),
    (0, class_validator_1.IsString)({
        message: "Start Time must be a string in time with time zone format (e.g., 10:00:00+05:30).",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        // Validate ISO 8601 time with time zone (e.g., 10:00:00+05:30)
        const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)([+-][0-1]\d:[0-5]\d|Z)$/;
        if (!regex.test(value)) {
            throw new common_1.BadRequestException("Start Time must be in 'HH:mm:ss±HH:mm' or 'HH:mm:ssZ' format.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateMeetingDto.prototype, "startTime", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Duration must be a number." }),
    (0, class_validator_1.Min)(1, {
        message: "Duration must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "End Time (time with time zone, ISO 8601 format)",
        type: String,
        example: "11:00:00+05:30",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "End time is required." }),
    (0, class_validator_1.IsString)({
        message: "End Time must be a string in time with time zone format (e.g., 11:00:00+05:30).",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        // Validate ISO 8601 time with time zone (e.g., 11:00:00+05:30)
        const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)([+-][0-1]\d:[0-5]\d|Z)$/;
        if (!regex.test(value)) {
            throw new common_1.BadRequestException("End Time must be in 'HH:mm:ss±HH:mm' or 'HH:mm:ssZ' format.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateMeetingDto.prototype, "endTime", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Location",
        type: Number,
        example: 300,
    }),
    (0, class_validator_1.IsInt)({ message: "Location type must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Location type must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "locationTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting subject",
        type: String,
        example: "Discuss project updates",
    }),
    (0, class_validator_1.IsString)({ message: "Meeting subject must be a string." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting subject is required." }),
    tslib_1.__metadata("design:type", String)
], CreateMeetingDto.prototype, "meetingSubject", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting Agenda",
        type: String,
        example: "Agenda for the meeting",
    }),
    (0, class_validator_1.IsString)({ message: "Meeting agenda must be a string." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting agenda is required." }),
    tslib_1.__metadata("design:type", String)
], CreateMeetingDto.prototype, "meetingAgenda", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Meeting status must be a number." }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "meetingStatusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "TPA participants",
        type: TpaParticipantsDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TpaParticipantsDto),
    tslib_1.__metadata("design:type", TpaParticipantsDto)
], CreateMeetingDto.prototype, "tpaParticipants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Insurer participants",
        type: InsurerParticipantsDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => InsurerParticipantsDto),
    tslib_1.__metadata("design:type", InsurerParticipantsDto)
], CreateMeetingDto.prototype, "insurerParticipants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Company participants",
        type: CompanyParticipantsDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CompanyParticipantsDto),
    tslib_1.__metadata("design:type", CompanyParticipantsDto)
], CreateMeetingDto.prototype, "companyParticipants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Employee participants",
        type: EmployeeParticipantsDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => EmployeeParticipantsDto),
    tslib_1.__metadata("design:type", EmployeeParticipantsDto)
], CreateMeetingDto.prototype, "employeeParticipants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Meeting documents",
        type: [CreateMeetingDocumentDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Meeting documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateMeetingDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateMeetingDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateMeetingDto.prototype, "updatedBy", void 0);
